import moment from "moment";

const
    days_between = (date1, date2) => {
        // The number of milliseconds in one day
        const ONE_DAY = 1000 * 60 * 60 * 24;

        // Calculate the difference in milliseconds
        const differenceMs = Math.abs(date1 - date2);

        // Convert back to days and return
        return Math.round(differenceMs / ONE_DAY);
    };


const
    days_age = (date) => {

        return days_between(new Date(), date)
    };




export default {
    getDecote: (date) => {

        const age = days_age(date);

        if (age <= 30) {
            return 1.00;
        }

        if (age <= 60) {
            return 0.75;
        }

        return 0.50;
    },

    age: (date) => {
        return days_between(new Date(), new Date(date));
    },

    matin: (date) => {
        let m = moment(date);
        return m.hour() < 12;
    },

    aujourdhui: date => {
        return moment(date).calendar(null, { sameDay: '[Today]', sameElse: '[Else]'}) === 'Today' ;
    },

    hier: date => {
        return moment(date).calendar(null, { lastDay: '[Yesterday]', sameElse: '[Else]' }) === 'Yesterday';
    },

    addDays: (date, days) => {
        let result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }
}




